var map = {
	"./apple_store": 4,
	"./apple_store.png": 4,
	"./black_apple_store": 5,
	"./black_apple_store.png": 5,
	"./black_google_play": 6,
	"./black_google_play.png": 6,
	"./favicon": 7,
	"./favicon.png": 7,
	"./google_play": 8,
	"./google_play.png": 8,
	"./logo_with_name": 9,
	"./logo_with_name.png": 9,
	"./og_home": 10,
	"./og_home.jpg": 10,
	"./spinner": 11,
	"./spinner.svg": 11,
	"./watermark": 12,
	"./watermark.png": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19;